export class PhaseRelease {
    phaseNumber: string;
    releaseNumber: string;
}
